import React, { Component, Fragment } from 'react'
import { Router, Link, Route, Switch, Redirect } from 'react-router-dom'
import './App.css'
import firebase from 'firebase'
import { changePatientsDatabase, locale, patientsDatabase, polyglot } from '../../../index'
import { Navigation } from '../../common/Navigation/Navigation'
import { CustomLink } from '../../common/CustomLink/CustomLink'

import logo from '../../../resources/images/logoImageOnly.svg'
import Login from '../Login/Login'
import PatientPicker from '../PatientPicker/PatientPicker'
import DoctorProfile from '../DoctorProfile/DoctorProfile'
import Home from '../Home/Home'
import PatientInsertion from '../PatientInsertion/PatientInsertion'
import PatientIdentification from '../PatientIdentification/PatientIdentification'
import Consultations from '../Consultations/Consultations'
import Footer from './Footer/Footer'
import Settings from '../Settings/Settings'
import Admissions from '../Admissions/Admissions'
import ConsultationScheduling from '../ConsultationScheduling/ConsultationScheduling'

import createBrowserHistory from 'history/createBrowserHistory'

import Loading from '../../common/Loading/Loading'
import ErrorBoundary from '../../common/ErrorBoundary/ErrorBoundary'
import Test from './Test'

import Auth, {Authenticator} from '@kenetto/kenetto-authenticator'
import { configurationAuth0 } from '../../../config'

const auth = new Auth(configurationAuth0, '/patients')

const history = createBrowserHistory({ basename: process.env.REACT_APP_ROUTER_BASE_PATH })

class App extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: undefined,
      configuration: undefined,
      currentPatientKey: undefined,
      currentPatient: undefined,
      hideProfileIndicator: false,
      polyglot: polyglot
    }
    this.getConfiguration = this.getConfiguration.bind(this)
    this.patientChangeHandle = this.patientChangeHandle.bind(this)
    this.logOut = this.logOut.bind(this)
    this.handleLanguageChange = this.handleLanguageChange.bind(this)
  }

  logOut () {
    auth.logout(history.push)
    this.setState({
      user: undefined,
      isAuthenticated: undefined,
      currentPatient: undefined,
      currentPatientKey: undefined
    })
    window.myLogger.info(JSON.stringify({message: 'User Logged Out'}))
  }

  patientChangeHandle (patientNumber) {
    if (patientNumber) {
      patientsDatabase.on('value', snapshot => {
        snapshot.forEach(childSnap => {
          if (childSnap.child('patientNumber').val() === patientNumber) {
            this.setState({
              currentPatient: childSnap.val(),
              currentPatientKey: childSnap.key
            })
          }
        })
      })
    } else {
      this.setState({
        currentPatient: undefined,
        currentPatientKey: undefined
      })
    }
    window.myLogger.info('Patient Changed', {patientNumber: patientNumber})
  }

  getConfiguration () {
    const rootRef = firebase.database().ref()
    const configurationRef = rootRef.child('crescendo').child('configurationByCountry').child(locale)
    configurationRef.on('value', snapshot => {
      this.setState({
        configuration: snapshot.val()
      })
    })
  }

  componentWillMount () {
    this.getConfiguration()
    if (auth.isAuthenticated()) {
      auth.getProfile((error, profile) => {
        if (error) {
          window.myLogger.error(error)
        }
        if (profile) {
          window.myLogger.info(JSON.stringify({message: 'User Info Object', user: profile}))
          this.setState({
            user: profile
          })
        }
      })
    }
  }

  componentWillUpdate (nextProps, nextState) {
    if (auth.isAuthenticated()) {
      if (!nextState.isAuthenticated) {
        this.setState({
          isAuthenticated: true
        })
      }
      auth.getProfile((error, profile) => {
        if (error) {
          window.myLogger.error(error)
        }
        if (profile) {
          window.myLogger.info(JSON.stringify({message: 'User Info Object', user: profile}))
          this.setState({
            user: profile
          })
        }
      })
    }
  }

  navigationContent () {
    let result = []
    if (this.state.currentPatient) {
      const patientNumber = this.state.currentPatient['patientNumber']
      result = [<CustomLink key={'home'} exact label={this.state.polyglot.t('staticFields.navigation.home')}
        to={`/patients/${patientNumber}/`} />,
        <CustomLink key={'identification'} label={this.state.polyglot.t('staticFields.navigation.identification')}
          to={`/patients/${patientNumber}/identification`} />,
        <CustomLink key={'consultations'} label={this.state.polyglot.t('staticFields.navigation.consultations')}
          to={`/patients/${patientNumber}/consultations`} />,
        <CustomLink key={'admissions'} label={this.state.polyglot.t('staticFields.navigation.admissions')}
          to={`/patients/${patientNumber}/admissions`} />]
    }
    return result
  }

  navigationBrand () {
    return <Link className={'navbar-brand'} to={'/patients'}><img className='navigation-logo' src={logo}
      alt='Logo' /></Link>
  }

  navigationRightContent () {
    return <Fragment>
      {this.state.currentPatient
        ? <CustomLink to={`/patients/${this.state.currentPatient['patientNumber']}/`}
          label={<Fragment>
            <span className='glyphicon glyphicon-user' />
            {this.state.currentPatient.name}
          </Fragment>} />
        : null
      }
      <li className='dropdown'>
        <a
          className='dropdown-toggle'
          data-toggle='dropdown'
          role='button'
          aria-haspopup='true'
          aria-expanded='false'>{this.state.polyglot.t('staticFields.navigation.settings')}<span className='caret' /></a>
        <ul className='dropdown-menu'>
          <li><Link to='/patients'
            onClick={() => this.patientChangeHandle(undefined, undefined)}>{this.state.polyglot.t('staticFields.navigation.changePatient')}</Link></li>
          <li><Link to='/patientInsertion'
            onClick={() => this.logOut}>{this.state.polyglot.t('staticFields.navigation.insertPatient')}</Link>
          </li>
          <li role='separator' className='divider' />
          <li><Link to='/doctorProfile'>{this.state.polyglot.t('staticFields.navigation.doctorProfile')}</Link></li>
          <li><Link to='/settings'>{this.state.polyglot.t('staticFields.navigation.settings')}</Link></li>
          <li><Link to='/' onClick={this.logOut}>{this.state.polyglot.t('staticFields.navigation.logout')}</Link></li>
        </ul>
      </li>
    </Fragment>
  }

  handleLanguageChange (polyglot, locale) {
    this.setState({
      polyglot: polyglot,
      currentPatient: undefined,
      currentPatientKey: undefined
    })
    changePatientsDatabase(locale)
  }

  renderSwitch () {
    return <Switch>
      <Route exact path='/' render={props => (
        <Login auth={auth} props{...props} />
      )} />
      <Route exact path={auth.callbackUrl} render={(props) => (
        <Authenticator auth={auth} {...props}>
          <Loading />
        </Authenticator>
        )} />
      <Route exact path='/patients' render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <PatientPicker
            auth={auth}
            patientChangeHandle={this.patientChangeHandle}
            props{...props} />
          )
      )} />
      <Route exact path='/doctorProfile' render={props => (
        <DoctorProfile
          configuration={this.state.configuration['doctorProfile']}
          doctorObject={this.state.user}
          auth={auth}
          patientChangeHandle={this.patientChangeHandle}
          props{...props} />
      )} />
      <Route exact path='/settings' render={props => (
        <Settings handleLanguageChange={this.handleLanguageChange} props{...props} />
      )} />
      <Route exact path='/consultationScheduling' render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <ConsultationScheduling
            auth={auth}
            configuration={this.state.configuration}
            props{...props} />
          )
      )} />
      <Route exact path='/patients/addPatient' render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <PatientInsertion
            auth={auth}
            configuration={this.state.configuration}
            props{...props} />)
          )} />
      <Route exact path='/patients/:patientId' render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <Home
            hidePatientIndicator={value => this.setState({hideProfileIndicator: value})}
            patient={this.state.currentPatient}
            patientKey={this.state.currentPatientKey}
            user={this.state.user}
            auth={auth}
            patientChangeHandle={this.patientChangeHandle}
            configuration={this.state.configuration}
            props{...props} />
          )
      )} />
      <Route exact path='/patients/:patientId/identification' render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <PatientIdentification
            hidePatientIndicator={value => this.setState({hideProfileIndicator: value})}
            patient={this.state.currentPatient}
            patientKey={this.state.currentPatientKey}
            user={this.state.user}
            auth={auth}
            patientChangeHandle={this.patientChangeHandle}
            configuration={this.state.configuration}
            props{...props} />
          )
      )} />
      <Route exact path='/patients/:patientId/consultations' render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <Consultations
            hidePatientIndicator={value => this.setState({hideProfileIndicator: value})}
            patient={this.state.currentPatient}
            patientKey={this.state.currentPatientKey}
            user={this.state.user}
            auth={auth}
            configuration={this.state.configuration}
            patientChangeHandle={this.patientChangeHandle}
            props{...props} />
          )
      )} />
      <Route exact path='/patients/:patientId/consultations/:rangeId' render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <Consultations
            hidePatientIndicator={value => this.setState({hideProfileIndicator: value})}
            patient={this.state.currentPatient}
            patientKey={this.state.currentPatientKey}
            user={this.state.user}
            auth={auth}
            configuration={this.state.configuration}
            patientChangeHandle={this.patientChangeHandle}
            props{...props} />
          )
      )} />
      <Route exact path='/patients/:patientId/admissions' render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <Admissions
            hidePatientIndicator={value => this.setState({hideProfileIndicator: value})}
            patient={this.state.currentPatient}
            patientKey={this.state.currentPatientKey}
            user={this.state.user}
            auth={auth}
            configuration={this.state.configuration}
            patientChangeHandle={this.patientChangeHandle}
            props{...props} />
          )
      )} />
      <Route path='/test' render={function () {
        return <Test />
      }} />
      <Route render={props => {
        window.myLogger.error('Attempting render wrong path', {url: props.location.pathname})
        return <p>{polyglot.t('staticFields.commonFields.notFound')}</p>
      }} />
    </Switch>
  }

  getPatientName (patient) {
    return patient && patient.name
  }

  getPatientPhoto (patient) {
    return patient && patient.photo
  }

  getDoctorName (doctor) {
    return doctor && doctor.nickname
  }

  render () {
    if (polyglot) {
      return <ErrorBoundary>
        <Router history={history} basename={process.env.REACT_APP_ROUTER_BASE_PATH}>
          {this.state.configuration ? <div className='full-screen'>
            {this.state.isAuthenticated
            ? <Fragment>
              <Navigation
                children={this.navigationContent()}
                brand={this.navigationBrand()}
                rightContent={this.navigationRightContent()} />
            </Fragment>
            : null
          }
            <div className={'container-fluid bottom-margin'}>
              {this.state.configuration
                ? <div className='col-xs-12 no-side-padding'>
                  {this.renderSwitch()}
                </div>
                : <Loading />
              }
            </div>
            <Footer />
          </div>
          : <Loading />
        }
        </Router>
      </ErrorBoundary>
    } else {
      return null
    }
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/general/App/App.js